// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import { utils } from '@cofit/api';
import { APP_NAME, APP_RELEASE_VERSION, APP_VERSION, BranchConstants, commonSettings, SW_VERSION } from '../constants/';
import { sentryConfig } from '../constants/sentry';
export var getSentry = function getSentry() {
  return typeof window.Sentry !== 'undefined' ? window.Sentry : true ? window.Sentry : undefined;
};
export var setUpSentryUser = function setUpSentryUser(user) {
  var _Sentry$setUser;

  var Sentry = getSentry();

  if (!BranchConstants.SITE_WISE_ENABLE_SENTRY || !sentryConfig.enableSentry || Sentry === undefined) {
    return;
  }

  Sentry === null || Sentry === void 0 ? void 0 : (_Sentry$setUser = Sentry.setUser) === null || _Sentry$setUser === void 0 ? void 0 : _Sentry$setUser.call(Sentry, {
    id: user.id,
    email: user.email,
    username: user.username,
    roles: user.roles
  });
};
export var setUpSentry = function setUpSentry() {
  var Sentry = getSentry();

  if (!BranchConstants.SITE_WISE_ENABLE_SENTRY || !sentryConfig.enableSentry || Sentry === undefined) {
    return;
  }

  Sentry.init({
    dsn: sentryConfig.dsn,
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1,
    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
    replaysOnErrorSampleRate: 1.0,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    integrations: [new Sentry.Replay({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
      slowClickIgnoreSelectors: ['button[e2eid="MediaViewer_index_Button"]' // e.g. pro2 image viewer button for enlarging images
      ]
    })],
    tunnel: sentryConfig.tunnelPath
  });
  Sentry.setContext('app', {
    APP_RELEASE_VERSION: APP_RELEASE_VERSION,
    APP_NAME: APP_NAME,
    APP_VERSION: APP_VERSION,
    WORKER_VERSION: SW_VERSION,
    isProduction: commonSettings.isProductionEnv
  });
  Sentry.setTag('ENV', commonSettings.BANNER_PREFIX || 'PRODUCTION');
  Sentry.setTag('isProduction', commonSettings.isProductionEnv);
  Sentry.addGlobalEventProcessor(utils.Sentry.addGlobalEventProcessor);
};